import FocusTrap from '@mui/material/Unstable_TrapFocus'
import React, { useEffect, useState } from 'react'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

import FilterWrapper from './filter/FilterWrapper'

const SearchResultsFilters = props => {
  if (!props.panelDisplayed.filter) return null

  const calculateOverlayHeight = () => {
    return document.documentElement.offsetHeight - 151
  }

  const [overlayHeight, setOverlayHeight] = useState(calculateOverlayHeight())

  useEffect(() => {
    setOverlayHeight(calculateOverlayHeight())
  }, [props])

  let panelOffsetLeft = props.panelDisplayed.offsetLeft
  if (document.documentElement.offsetWidth - 528 < panelOffsetLeft) {
    panelOffsetLeft = document.documentElement.offsetWidth - 528
  }

  return (
    <>
      <div
        className={`[ f-hidden:s ] SearchResultsFilters-overlay ${
          props.variant && props.variant.includes('embedded')
            ? 'is-embedded'
            : ''
        }`}
        style={{
          height:
            props.variant && props.variant.includes('embedded')
              ? '100%'
              : overlayHeight
        }}
        onClick={() => props.displayPanel({})}
      />
      <FocusTrap open>
        <div
          tabIndex={-1}
          className={`[ f-d-flc f-c-ba-whi f-p-a-020 f-m-v-020 ] SearchResultsFilters-container ${
            props.panelDisplayed.filter === 'more-filters' ? 'is-large' : ''
          }`}
          style={{ left: panelOffsetLeft }}>
          <div className='[ f-d-flr f-p-b-020 f-hidden:m f-hidden:l ] SearchResultsFilters-container-top'>
            <CTA
              type='text-primary'
              tag='a'
              className='[ f-t-body f-t-bold ]'
              onClick={
                props.panelDisplayed.filter === 'more-filters'
                  ? () => {
                      props.resetAllFilters()
                      props.displayPanel({})
                    }
                  : () => props.removeFilter(props.panelDisplayed.filter)
              }>
              Zurücksetzen
            </CTA>
            <CTA
              type='icon'
              tag='a'
              className='SearchResultsFilters-close'
              onClick={() => props.displayPanel({})}>
              <Icon
                icon='close-16px'
                className='[ f-icon-030 f-c-st-neu200 ]'
              />
            </CTA>
          </div>
          <div
            className={`SearchResultsFilters-container-content ${
              props.panelDisplayed.filter === 'delivery_regions'
                ? 'is-location'
                : ''
            }`}>
            <FilterWrapper
              filtersList={
                props.panelDisplayed.filter === 'more-filters'
                  ? props.availableFilters.filter(
                      filter =>
                        !/price|delivery_regions|living_area_total|has_floor_plans|form/.test(
                          filter.name
                        )
                    )
                  : props.availableFilters.filter(
                      filter => filter.name === props.panelDisplayed.filter
                    )
              }
              slots={
                props.panelDisplayed.filter === 'price'
                  ? props.apiResult.slots
                  : undefined
              }
              updateParams={props.updateParams}
              filters={props.filters}
              params={props.params}
              searchType='houses'
            />
          </div>
          <div
            className={`[ f-d-flr f-p-t-020 ] SearchResultsFilters-container-bottom ${
              props.panelDisplayed.filter === 'more-filters' ? 'has-shadow' : ''
            }`}>
            {props.panelDisplayed.isActive && (
              <CTA
                type='text-primary'
                className='[ f-t-body f-t-bold f-hidden:s ]'
                onClick={
                  props.panelDisplayed.filter === 'more-filters'
                    ? () => {
                        props.resetAllFilters()
                        props.displayPanel({})
                      }
                    : () => props.removeFilter(props.panelDisplayed.filter)
                }
                wtData={{
                  'CTA-click': {
                    label: 'filter-reset',
                    location: 'filter-panel'
                  }
                }}>
                Zurücksetzen
              </CTA>
            )}
            <CTA
              type='block-primary'
              className='SearchResultsFilters-cta'
              onClick={() => props.displayPanel({})}
              wtData={{
                'CTA-click': {
                  label: 'filter-close',
                  location: 'filter-panel'
                }
              }}>
              Anwenden
            </CTA>
          </div>
        </div>
      </FocusTrap>
    </>
  )
}

export default SearchResultsFilters
